import { useEffect, useState } from 'react';

export default function useFetch<T>(path: string): {
    data: T | null;
    error: string;
    loading: boolean;
} {
    const [data, setData] = useState<T | null>(null);
    const [error, setError] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        async function getData() {
            if (!path) {
                throw new Error('Address for API call has been not provided.');
            }

            const response = await fetch(path);
            return (await response.json()) as T;
        }

        setError('');
        setLoading(true);

        getData()
            .then(setData)
            .catch(setError)
            .finally(() => setLoading(false));
    }, [path]);

    return { data, error, loading };
}
